import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ToxOffering from "@/pages/ToxOffering";

export const Route = createFileRoute("/en/services/regulatory-toxicology/biocompatibility-biological-evaluation")({
  head: () =>
    buildRouteHead("/en/services/regulatory-toxicology/biocompatibility-biological-evaluation", {
      title: "Biocompatibility & Biological Evaluation Solutions | QbD Group",
      description:
        "QbD Group supports medical device manufacturers with end-to-end biocompatibility and biological evaluation under ISO 10993, from feasibility to submission-ready BER.",
    }),
  component: ToxOffering,
});
